export default __webpack_public_path__ + "static/media/marvinLogo.35feeb62.png";